// extracted by mini-css-extract-plugin
export default {"melodyVideo":"RK-z","isFullWidth":"SK-z","landingPageVideo":"TK-z","play":"UK-z","iframeVideo":"VK-z","playHidden":"WK-z","fullwidth":"XK-z"};